<template>
    <div id="content">
        <div class="container">
            <ul class="breadcrumb">
                <!--<li class="icon"><img src="/themes/ito/images/icon-profile.svg" alt=""></li>-->
                <router-link class="icon" :to="{ path: '/' }"><img src="/themes/ito/images/icon-profile.svg" alt="">
                </router-link>
                <li class="active">{{ $t('profile') }}</li>
            </ul>

            <div class="card card-profile">
                <div class="card-body">
                    <h5 class="card-title">
                        <span class="title">{{ $t('basic_info') }}</span>
                        <a href="#" @click.prevent="onLogout">
                            <span class="logout">{{ $t('log_out') }}</span>
                        </a>
                    </h5>

                    <div class="card-content">
                        <div class="profile-show">
                            <div class="profile-avatar-upload">
                                <div class="profile-avatar-upload-c" :style="{ backgroundImage: `url(${user_info.avatar_url})` }"></div>

                                <a href="#" class="upload-btn" data-bs-toggle="modal" data-bs-target="#uploadAvatarModal">
                                    <img src="/themes/ito/images/icon-camera-upload.svg" alt="" />
                                </a>

                                <div class="emoticon" v-if="user_info.emoji_url">
                                    <img :src="user_info.emoji_url" alt="" />
                                </div>
                            </div>

                            <div class="profile-avatar-info">
                                <div class="profile-info-item">{{ $t('user_id') }}: <span class="value">{{ user_info.user_id
                                }}</span></div>
                                <div class="profile-info-item" v-show="user_info.student_type != 2">
                                    <span>{{ $t('total') }}:</span>
                                    <div class="profile-info-item-gem">
                                        <span class="value">{{ user_info.gem | toCommas }}</span>
                                        <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                                        <span class="mx-1">|</span>
                                        <span class="value">{{ user_info.crown | toCommas }}</span><i class="ito-icon-2"></i>

                                    </div>
                                </div>
                                <div class="profile-info-item" v-show="user_info.student_type != 2">{{ $t('this_month') }}:
                                    <div class="profile-info-item-gem">
                                        <span class="value">{{ user_info.gem_month | toCommas }}</span>
                                        <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                                        <span class="mx-1">|</span>
                                        <span class="value">{{ user_info.crown_month | toCommas }}</span><i class="ito-icon-2"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="profile-avatar-button" v-if="user.student_type != 2">
                                <button class="btn btn-default btn-change-password" @click="changePassword()">{{
                                    $t('change_password') }}
                                </button>
                            </div>
                        </div>
                        <div class="profile-update">
                            <form>
                                <div class="row">
                                    <label class="col-sm-12 col-form-label">{{ $t('full_name') }}</label>
                                    <div class="col-sm-12">
                                        <input type="text" name="fullname" class="form-control" v-model="user.fullname" :placeholder="$t('full_name')" @input="eventValid" :disabled="user_info.student_type == 1">
                                        <div class="error-message has-form" v-if="errors.fullname">{{ errors.fullname
                                        }}
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="user_info.student_type != 2">
                                    <div class="col-sm-6">
                                        <label class="col-form-label">{{ $t('birthday') }}</label>
                                        <div class="">
                                            <input readonly="true" type="text" name="birthday" class="form-control date datepicker birthday" v-model="user.birthday" autocomplete="off" :placeholder="$t('birthday')" />
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="col-form-label">{{ $t('gender') }}</label>
                                        <div class="">
                                            <select class="form-control" name="gender" v-model="user.gender" @change="eventValid">
                                                <option value="">{{ $t('select_gender') }}</option>
                                                <option value="male" selected>{{ $t('male') }}</option>
                                                <option value="female">{{ $t('female') }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="user_info.student_type != 2">
                                    <div class="col-sm-6" v-if="user_info.student_type == 1">
                                        <label class="col-form-label">{{ $t('class') }}</label>
                                        <div class="">
                                            <input type="text" name="class" class="form-control" :value="user_info.class" disabled autocomplete="off">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="col-form-label">{{ $t('grade') }}</label>
                                        <div style="position: relative">
                                            <input type="text" name="grade" class="form-control" :value="user.grade" disabled autocomplete="off">
                                            <!--<i :class="calcPercent(extension.process,extension.total) == 100? 'ito-icon-checked':'ito-icon-checked-disable'"></i>-->
                                            <i :class="user_info.placement_test != 0 ? 'ito-icon-checked' : 'ito-icon-checked-disable'" style="position: absolute;bottom: 12px;right: 10px;"></i>
                                        </div>
                                    </div>
                                    <div class="col-sm-6" v-if="user_info.student_type == 0 && user_info.placement_test == 0">
                                        <div class="col-form-label test_button" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#placementModal">{{ $t('placement_test') }}</div>
                                    </div>
                                </div>
                                <div class="row" v-if="user_info.student_type == 2">
                                    <div class="col-sm-6">
                                        <label class="col-form-label">{{ $t('grade') }}</label>
                                        <div style="position: relative">
                                            <input type="text" name="grade" class="form-control" :value="user.grade" disabled autocomplete="off">
                                            <!--<i :class="calcPercent(extension.process,extension.total) == 100? 'ito-icon-checked':'ito-icon-checked-disable'"></i>-->
                                            <i v-if="(user_info.grade != 1 && user_info.placement_test != 0) || user_info.grade != 1" :class="user_info.placement_test != 0 ? 'ito-icon-checked' : 'ito-icon-checked-disable'"
                                                style="position: absolute;bottom: 12px;right: 10px;"></i>
                                        </div>
                                    </div>
                                    <div class="col-sm-6" v-if="user_info.student_type == 2 && user_info.placement_test == 0 && user_info.grade != 1">
                                        <div class="col-form-label test_button" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#placementModal">{{ $t('placement_test') }}</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <label class="col-form-label">{{ $t('phone') }}</label>
                                        <div class="position-relative d-flex gap-3">
                                            <input type="text" name="grade" class="form-control custom-input  mb-0" :class="user.phone_verified ? 'is-valid' : 'is-warning'" :value="user.phone" disabled autocomplete="off">
                                            <router-link :to="{ name: 'account_verify', params: { tab: 'phone' } }" class="ito-btn ito-btn-warning" @click.native="getSoundClick" v-if="!user.phone_verified">
                                                {{ $t('btn_verify') }}
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <label class="col-form-label">{{ $t('email') }}</label>
                                        <div class="position-relative d-flex gap-3">
                                            <input type="text" name="grade" class="form-control custom-input mb-0" :class="user.email_verified ? 'is-valid' : 'is-warning'" :value="user.email" disabled autocomplete="off">
                                            <router-link :to="{ name: 'account_verify', params: { tab: 'email' } }" class="ito-btn ito-btn-warning" @click.native="getSoundClick" v-if="!user.email_verified">
                                                {{ $t('btn_verify') }}
                                            </router-link>
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>

                    <div class="card-bottom" v-if="user_info.student_type != 2">
                        <button :class="is_valid ? 'ito-btn-small active' : 'ito-btn-small'" @click="onSubmit">
                            {{ $t('save') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="uploadAvatarModal" tabindex="-1" aria-labelledby="uploadAvatarModal" aria-hidden="true" data-bs-backdrop="static" data-keyboard="false">
            <div class="modal-dialog" style="width: 646px;">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="upload-avatar">
                            <div class="upload-avatar-info">
                                <h3 class="title">{{ $t('student_profile') }}</h3>

                                <div class="avatar">
                                    <div class="avatar-c" ref="avatar_url" :style="{ backgroundImage: `url(${user_info.avatar_url})` }"></div>

                                    <img ref="emoticon_url" class="emoticon" :class="user.emoji_url ? 'emo_show' : 'emo_hide'" :src="user_info.emoji_url ? user_info.emoji_url : ''" alt="">
                                </div>

                                <div v-if="is_show_button_update_avatar">
                                    <button class="btn btn-default btn-update" :disabled="disable_button_update_avatar" @click="updateAvatar">
                                        {{ $t('save') }}
                                    </button>
                                </div>
                                <div v-if="is_show_button_update_emoticon">
                                    <button class="btn btn-default btn-update" :disabled="disable_button_update_emoticon" @click="updateAvatar">
                                        {{ $t('save') }}
                                    </button>
                                </div>
                                <div>
                                    <button class="btn btn-default btn-cancel mt12" data-bs-dismiss="modal" aria-label="Close">{{ $t('cancel') }}</button>
                                </div>
                            </div>
                            <div class="upload-avatar-select">
                                <div class="upload-avatar-tabs">
                                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">{{ $t('avatar') }}
                                            </button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">{{ $t('emoticon') }}
                                            </button>
                                        </li>
                                    </ul>

                                    <div class="tab-content">
                                        <div class="tab-pane active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                            <div class="avatar-list nano">
                                                <div class="nano-content">
                                                    <div class="row" style="margin-right: -10px; margin-left: -10px;">
                                                        <!-- <div class="col-md-3 avatar-item" style="margin-top: 18px;">
                                                            <div class="thumb">
                                                                <div class="thumb-content">
                                                                    <label class="avatar-item-upload" for="uploadAvatar">
                                                                        <img src="/themes/ito/images/avatar-0.svg?v=2"
                                                                            alt="">
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <input type="file" id="uploadAvatar" name="avatar"
                                                                accept="image/*" style="display: none" @change="addEvent" />
                                                        </div> -->
                                                        <div class="col-md-3 avatar-item" v-for="(avatar, index) in avatars" :key="index" @click="selectAvatar(avatar)">
                                                            <div class="thumb">
                                                                <div class="thumb-content">
                                                                    <img :src="avatar.url" alt="">

                                                                    <div class="avatar-item-checked" v-if="avatar.id == user.avatar_id">
                                                                        <i class="ito-icon-checked"></i>
                                                                    </div>
                                                                    <div class="avatar-item-gem d-flex align-items-center" v-else-if="avatar.price > 0">
                                                                        <span class="ito-gem">{{ avatar.price }}</span>
                                                                        <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                            <div class="avatar-list nano">
                                                <div class="nano-content">
                                                    <div class="row" style="margin-right: -10px; margin-left: -10px;">
                                                        <div class="col-md-3 avatar-item" v-for="(emoticon, index) in emoticons" :key="index" @click="selectEmoticon(emoticon)">
                                                            <div class="thumb">
                                                                <div class="thumb-content">
                                                                    <img :src="emoticon.url" alt="">

                                                                    <div class="avatar-item-checked" v-if="emoticon.id == user.emoji_id">
                                                                        <i class="ito-icon-checked"></i>
                                                                    </div>
                                                                    <div class="avatar-item-gem d-flex align-items-center" v-else-if="emoticon.price > 0">
                                                                        <span class="ito-gem">{{ emoticon.price }}</span>
                                                                        <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <img class="modal-close" src="/themes/ito/images/icon-close-1.svg" alt="" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="cropAvatarModal" tabindex="-1" aria-labelledby="cropAvatarModal" aria-hidden="true" data-bs-backdrop="static" data-keyboard="false">
            <div class="modal-dialog" style="width: 473px;">
                <div class="modal-content">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20">{{ $t('edit_image') }}</h3>

                    <div class="modal-body">
                        <div class="image-crop-content">
                            <img id="image-crop" :src="avatar_crop_data">
                        </div>

                        <div class="mt-20 text-center">
                            <label class="avatar-item-upload" for="uploadAvatar">
                                <button class="btn btn-default btn-choose-image" @click="chooseImage">
                                    {{ $t('choose_image') }}
                                </button>
                            </label>
                            <button class="btn btn-default btn-update" @click="cropSave">{{ $t('save') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="errorModal" tabindex="-1" aria-labelledby="errorModal" aria-hidden="true" data-bs-backdrop="static" data-keyboard="false">
            <div class="modal-dialog" style="width: 400px;">
                <div class="modal-content">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20">{{ $t('has_error') }}</h3>

                    <div class="modal-body text-center">
                        <div>
                            <img src="/themes/ito/images/image01/icon-error.svg" alt="">
                        </div>

                        <div class="message">{{ error_message }}</div>

                        <div>
                            <button class="btn btn-default btn-update" @click="chooseImage">{{ $t('choose_image') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModal" aria-hidden="true" data-keyboard="true">
            <div class="modal-dialog modal-dialog-centered" style="width: 380px;">
                <div class="modal-content">
                    <div class="modal-header border-0">
                        <div class="close-popup" data-bs-dismiss="modal"></div>
                        <h5 class="popup-title">{{ $t('has_success') }}</h5>
                    </div>
                    <div class="modal-body text-center">
                        <div class="message">{{ $t('profile_update_success') }}</div>
                    </div>
                </div>
            </div>
        </div>

        <ChangePasswordModal></ChangePasswordModal>
        <ChangePasswordSuccessModal></ChangePasswordSuccessModal>

    </div>
</template>

<script>
import { getAvatars, updateAvatar, updateProfile } from '../../models/profile'
import ChangePasswordModal from '../modal/ChangePasswordModal.vue';
import ChangePasswordSuccessModal from '../modal/ChangePasswordSuccessModal.vue';
import axios from "axios";
import '/public/themes/ito/css/profile.css';
import 'cropperjs/dist/cropper.css';
import Cropper from 'cropperjs';
import AppIcon from '@/components/common/AppIcon.vue';

export default {
    name: "Profile",
    title: 'Profile',
    components: { ChangePasswordModal, ChangePasswordSuccessModal, AppIcon },

    data() {
        return {
            errors: {
                address: '',
                fullname: '',
            },
            user: {
                fullname: '',
                birthday: '',
                gender: '',
                grade: 0,
                type: 2,
                avatar_id: -1,
                avatar_id_before: -1,
                avatar_img: '',
                emoji_id: 0,
                emoji_id_before: 0,
                extension_file: 'png',
                student_type: 0,
                user_name: '',
                change_avatar: 0,
                change_emoji: 0,
                phone: '',
                email: '',
                phone_verified: 0,
                email_verified: 0,
            },
            avatar: '',
            avatars: [],
            emoticons: [],
            avatar_crop_data: '',
            is_show_button_update_avatar: true,
            disable_button_update_avatar: true,
            disable_button_update_emoticon: true,
            is_show_button_update_emoticon: false,
            cropper: null,
            error_message: '',
            is_valid: false,
        };
    },

    computed: {
        user_info() {
            const user = this.$store.state.user_info;
            this.user.fullname = user.fullname;
            this.user.birthday = user.birthday;
            this.user.gender = user.gender;
            this.user.grade = user.grade;
            this.user.avatar_id = user.avatar_id;
            this.user.avatar_id_before = user.avatar_id;
            this.user.emoji_id = user.emoji_id;
            this.user.emoji_id_before = user.emoji_id;
            this.user.emoji_url = user.emoji_url;
            this.user.avatar_img = user.avatar_url;
            this.user.student_type = user.student_type;
            this.user.user_name = user.username;
            this.user.phone = user.phone;
            this.user.phone_verified = user.phone_verified;
            this.user.email = user.email;
            this.user.email_verified = user.email_verified;
            this.user.change_avatar = 0;
            this.user.change_emoji = 0;
            //this.$store.state.user_info.student_type = 1;

            return this.$store.state.user_info
        }
    },

    created() {
        this.fetch();
    },

    methods: {
        fetch() {
            const that = this;

            axios.all([
                getAvatars(),
            ]).then(axios.spread((response) => {
                if (response.data.code != 0) {
                    return;
                }

                const items = response.data.results.items || [];

                items.forEach(function (item) {
                    if (item.type == 0) {
                        that.avatars.push(item)
                    }
                    if (item.type == 1) {
                        that.emoticons.push(item)
                    }
                });
            }));

            this.$nextTick(function () {
                $('.birthday').datepicker({
                    dateFormat: 'dd/mm/yy',
                    changeMonth: true,
                    changeYear: true,
                    showOtherMonths: true,
                    selectOtherMonths: false,
                    yearRange: '1900:+0',
                    maxDate: new Date(),
                    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                }).on('change', (e) => {
                    this.searchEvent(e);
                });

                initNanoScroller();
                $('button[data-bs-toggle="tab"]').on('show.bs.tab', function (e) {
                    initNanoScroller();
                });
                $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
                    //console.log(e.currentTarget.id)

                    if (e.currentTarget.id == 'home-tab') {
                        that.is_show_button_update_avatar = true;
                        that.is_show_button_update_emoticon = false;
                    }
                    if (e.currentTarget.id == 'profile-tab') {
                        that.is_show_button_update_avatar = false;
                        that.is_show_button_update_emoticon = true;
                    }

                    initNanoScroller();
                });
                $('#uploadAvatarModal').on('shown.bs.modal', function () {
                    initNanoScroller();
                });
            })
        },

        showError(message) {
            this.error_message = message;

            $('.modal').modal('hide');

            $('#errorModal').modal('show');
        },

        chooseImage() {
            if (this.cropper != null) {
                this.cropper.destroy();
            }

            $('.modal').modal('hide');

            $('#uploadAvatarModal').modal('show');
        },

        cropSave() {
            const that = this;
            that.$store.commit("setLoading", true);
            const croppedImageDataURL = that.cropper.getCroppedCanvas().toDataURL("image/png");
            that.user.change_avatar = 1;
            updateAvatar({
                avatar_id: -1,
                avatar_img: croppedImageDataURL,
                extension_file: 'png',
            }).then((response) => {
                that.$store.commit("setLoading", false);
                $('#cropAvatarModal').modal('hide');
                that.cropper.destroy();
                if (response.data.code != 0) {
                    that.showError(response.data.msg)
                    return;
                }
                const time = new Date().getTime();
                that.user_info.avatar_id = response.data.results.avatar_id;
                that.user_info.avatar_url = response.data.results.avatar_url + '?v=' + time;
            }).catch((response) => {
                that.$store.commit("setLoading", false);
                $('#cropAvatarModal').modal('hide');
                that.cropper.destroy();
            });
        },

        searchEvent({ target }) {
            this.user[target.name] = target.value;

            this.is_valid = this.isChangeForm();
        },

        addEvent({ target }) {
            const that = this;

            switch (target.name) {
                case 'avatar':
                    const reader = new FileReader();

                    const images = target.files;

                    if (images.length == 0) {
                        break;
                    }

                    const image = images[0];

                    that.avatar = image;
                    reader.onload = function (e) {
                        that.avatar_crop_data = e.target.result;
                        that.disable_button_update_avatar = false;
                    };

                    if (/\.(jpe?g|png|gif)$/i.test(image.name)) {
                        reader.readAsDataURL(image);
                    }

                    this.$nextTick(function () {
                        $('#uploadAvatarModal').modal('hide');
                        $('#cropAvatarModal').on('shown.bs.modal', function () {
                            if (that.cropper != null) {
                                that.cropper.destroy();
                            }
                            that.cropper = new Cropper(
                                document.getElementById('image-crop'), {
                                aspectRatio: 1,
                                crop(event) {
                                    //console.log(event);
                                }
                            });
                        }).modal();
                    });

                    break;
            }
        },

        selectAvatar(avatar) {
            this.user.avatar_id = avatar.id;
            this.user.avatar_img = avatar.url;
            this.user.change_avatar = 1;
            this.$refs.avatar_url.style.backgroundImage = "url('" + avatar.url + "')";

            if (this.user.avatar_id_before != avatar.id) {
                this.disable_button_update_avatar = false;
            } else {
                this.disable_button_update_avatar = true;
            }
        },

        selectEmoticon(emoticon) {
            this.user.emoji_id = emoticon.id;
            this.user.emoji_url = emoticon.url;
            this.user.change_emoji = 1;
            this.$refs.emoticon_url.setAttribute("src", emoticon.url);

            if (this.user.emoji_id_before != emoticon.id) {
                this.disable_button_update_emoticon = false;
            } else {
                this.disable_button_update_emoticon = true;
            }
        },

        updateAvatar() {
            const that = this;
            const formData = new FormData();

            formData.append('avatar_id', this.user.avatar_id);
            formData.append('avatar_img', this.user.avatar_img);
            formData.append('emoji_id', this.user.emoji_id ? this.user.emoji_id : 0);
            // formData.append('emoji_id', this.user.emoji_id);
            formData.append('type', this.user.type);
            formData.append('extension_file', this.user.extension_file);

            that.$store.commit("setLoading", true);
            if (this.user.change_avatar != 0 && this.user.change_emoji != 0) {
                this.user.type = 2;
            } else if (this.user.change_avatar != 0) {
                this.user.type = 0;
            } else {
                this.user.type = 1;
            }
            updateAvatar({
                avatar_id: this.user.avatar_id,
                avatar_img: this.user.avatar_img,
                emoji_id: this.user.emoji_id ? this.user.emoji_id : 0,
                type: this.user.type,
                extension_file: this.user.extension_file,
                //is_raw: true
            }).then((response) => {
                that.$store.commit("setLoading", false);

                that.disable_button_update_avatar = true;
                that.disable_button_update_emoticon = true;

                console.log(response)

                if (response.data.code != 0) {
                    alert(response.data.msg)

                    return;
                }

                const time = new Date().getTime();

                that.user_info.avatar_id = response.data.results.avatar_id;
                that.user_info.avatar_url = response.data.results.avatar_url + '?v=' + time;
                that.user_info.emoji_id = response.data.results.emoji_id;
                that.user_info.emoji_url = response.data.results.emoji_url;

                $('#uploadAvatarModal').modal('hide');

                $('#successModal').modal('show');
            }).catch((response) => {
                that.$store.commit("setLoading", false);

                that.disable_button_update_avatar = true;

                console.error(response)
            });
        },

        onSubmit(e) {
            const that = this;
            if (that.is_valid == false) {
                return false;
            }
            const formData = new FormData();

            formData.append('fullname', this.user.fullname);
            formData.append('birthday', moment(this.user.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD'));
            formData.append('gender', this.user.gender);
            that.$store.commit("setLoading", true);
            updateProfile(formData).then((response) => {
                that.$store.commit("setLoading", false);
                if (response.data.code != 0) {
                    alert(response.data.msg)
                    return;
                }
                that.user_info.fullname = response.data.results.fullname;
                that.user_info.birthday = moment(response.data.results.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY');
                that.user_info.gender = response.data.results.gender;
                $('#successModal').modal('show');
                that.is_valid = false;
            }).catch((response) => {
                that.$store.commit("setLoading", false);
                console.error(response)
            });
            e.preventDefault();
        },

        onLogout() {
            $('#confirmLogout').modal('show');
        },
        changePassword() {
            $('#ChangePasswordPopup').modal('show');
        },

        eventValid({ target }) {
            this.is_valid = true;
            this.is_valid = this.isChangeForm();

            switch (target.name) {
                case 'fullname':
                    this.errors.fullname = '';
                    if (this.user.fullname.length > 50) {
                        this.errors.fullname = "Fullname max 50 characters.";
                        this.is_valid = false;
                    }
                    if (this.regexSpecialChar(this.user.fullname)) {
                        this.errors.fullname = "Fullname cannot contain special characters";
                        this.is_valid = false;
                    }

                    break;
            }
            return this.is_valid;
        },
        isChangeForm() {
            if (this.user_info.fullname != this.user.fullname
                || (this.user.gender != 0 && this.user_info.gender != this.user.gender)
                || this.user_info.birthday != this.user.birthday) {
                return true;
            }

            return false;
        },
        regexSpecialChar(txt) {
            var specialRegex = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;
            if (txt.match(specialRegex)) {
                return true;
            }
            return false;
        },
    }
}
</script>

<style scoped>
/*only this page*/
.form-control[readonly]:disabled {
    background: #EEF0F7;
}

.ito-input {
    width: 280px;
}

.form-group {
    margin-bottom: 0;
    margin-top: 10px;
}

p {
    margin-bottom: 0;
}

.label-input {
    margin-bottom: 0;
}

.error-message {
    margin-top: 5px;
}

/*only this page*/

.forgot-popup {
    width: 550px;
    max-width: 550px;
}

.forgot-popup .modal-content {
    position: relative;
    height: 470px;
    padding: 0px;
}

.forgot-popup-header {
    border-bottom: 1px solid #E5E5E5;
    padding: 20px 0;
}

.forgot-popup-content {
    position: relative;
    height: 320px;
    padding: 20px 50px;
}

.forgot-popup-footer {
    border-top: 1px solid #E5E5E5;
    padding: 20px 0;
}

.popup-title {
    margin-bottom: 0;
}

.forgot-popup-content {
    font-size: 14px;
    line-height: 19px;
    margin: 0;
}

/*validate*/

.validate-new-pass {
    display: flex;
    height: 40px;
    margin-left: 10px;
    flex-direction: column;
    justify-content: space-evenly;
}

.progres-status-pw-item {
    width: 18px;
    height: 8px;
    border: 1px solid #000;
    border-radius: 3px;
    margin-right: 4px;
}

.progres-text-pw {
    display: block;
    height: 12px;
    line-height: 12px;
    font-size: 12px;
    font-weight: 700;
}

.pw-weak .progres-status-pw-item.active {
    background: #FA450F;
    border-color: #FA450F;
}

.pw-normal .progres-status-pw-item.active {
    background: #FFA800;
    border-color: #FFA800;
}

.pw-strong .progres-status-pw-item.active {
    background: #98C93C;
    border-color: #98C93C;
}

.pw-weak .progres-text-pw {
    color: #FA450F;
}

.pw-normal .progres-text-pw {
    color: #FFA800;
}

.pw-strong .progres-text-pw {
    color: #98C93C;
}

.modal-success {
    text-align: center;
}

.modal-success .title {
    font-size: 24px;
    text-align: center;
    font-weight: 700;
}

.modal-success h6 {
    margin: 15px 0px 0px;
    font-size: 14px;
    line-height: 19px;
}

.input-pass {
    width: 280px;
}

.cropper {
    height: 215px;
    background: #DDD;
}

.form-control[readonly] {
    background-color: #ffffff;
}

.error-message.has-form {
    margin-bottom: 10px;
    margin-top: -10px;
}

.ito-btn-small {
    border: 1px solid transparent;
}

.emo_show {
    opacity: 1;
}

.emo_hide {
    opacity: 0;
}

.profile-update .col-form-label {
    text-align: left;
}

.test_button {
    color: #40c0f6;
    text-decoration: underline;
    cursor: pointer;
    margin-top: 40px;
    font-size: 15px;
}

.custom-input.is-warning {
    padding-right: calc(1.5em + 0.75rem);
    background-image: url('data:image/svg+xml,<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7965 10.748L8.29845 1.24805C8.16655 1.02053 7.97718 0.831676 7.74932 0.70039C7.52145 0.569104 7.26309 0.5 7.00011 0.5C6.73713 0.5 6.47877 0.569104 6.2509 0.70039C6.02304 0.831676 5.83367 1.02053 5.70177 1.24805V1.24853L0.203722 10.748C0.071719 10.976 0.00208671 11.2347 0.00183176 11.4982C0.00157681 11.7616 0.0707082 12.0205 0.20227 12.2487C0.333832 12.4769 0.523184 12.6665 0.751272 12.7983C0.979361 12.9301 1.23814 12.9995 1.50157 12.9995H12.4986C12.7621 12.9995 13.0209 12.9301 13.2489 12.7983C13.477 12.6665 13.6664 12.4769 13.7979 12.2487C13.9295 12.0205 13.9986 11.7616 13.9984 11.4982C13.9981 11.2347 13.9285 10.976 13.7965 10.748ZM6.49962 5.5C6.49962 5.36739 6.5523 5.24021 6.64607 5.14645C6.73984 5.05268 6.86701 5 6.99962 5C7.13223 5 7.25941 5.05268 7.35318 5.14645C7.44694 5.24021 7.49962 5.36739 7.49962 5.5V8C7.49962 8.13261 7.44694 8.25978 7.35318 8.35355C7.25941 8.44732 7.13223 8.5 6.99962 8.5C6.86701 8.5 6.73984 8.44732 6.64607 8.35355C6.5523 8.25978 6.49962 8.13261 6.49962 8V5.5ZM6.99999 11.0002C6.85165 11.0002 6.70665 10.9562 6.58331 10.8738C6.45997 10.7914 6.36384 10.6742 6.30708 10.5372C6.25031 10.4001 6.23546 10.2493 6.2644 10.1039C6.29334 9.95838 6.36477 9.82474 6.46966 9.71985C6.57455 9.61496 6.70818 9.54353 6.85367 9.51459C6.99916 9.48565 7.14995 9.5005 7.287 9.55727C7.42404 9.61404 7.54118 9.71017 7.62359 9.8335C7.706 9.95684 7.74999 10.1018 7.74999 10.2502C7.74998 10.4491 7.67096 10.6398 7.53031 10.7805C7.38966 10.9211 7.1989 11.0002 6.99999 11.0002Z" fill="%23FA450F"/></svg>');
    background-repeat: no-repeat;
    background-position: center right calc(0.375em + 0.1875rem);
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.custom-input.is-valid {
    border-color: rgba(228, 228, 228, 0.6);
    padding-right: calc(1.5em + 0.75rem);
    background-image: url('data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM13.7682 6.64018C14.1218 6.21591 14.0645 5.58534 13.6402 5.23178C13.2159 4.87821 12.5853 4.93554 12.2318 5.35982L8.63383 9.67736C8.28711 10.0934 8.09219 10.3238 7.93658 10.4653L7.93063 10.4707L7.92422 10.4659C7.75643 10.339 7.54146 10.1272 7.1585 9.74428L5.70711 8.29289C5.31658 7.90237 4.68342 7.90237 4.29289 8.29289C3.90237 8.68342 3.90237 9.31658 4.29289 9.70711L5.74428 11.1585L5.78511 11.1993L5.78512 11.1993C6.11161 11.526 6.4257 11.8402 6.71794 12.0611C7.0453 12.3087 7.47402 12.5415 8.02343 12.5165C8.57284 12.4916 8.97872 12.221 9.28233 11.9448C9.55337 11.6983 9.83772 11.3569 10.1333 11.0021L10.1333 11.0021L10.1703 10.9577L13.7682 6.64018Z" fill="%2398C93C"/></svg>');
    background-repeat: no-repeat;
    background-position: center right calc(0.375em + 0.1875rem);
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
</style>